import React from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import shallow from 'zustand/shallow';
import { UNTD_LAYERS } from './../../../../../constants/layers';
import { getRoundedValue, getFeatureId, hasValue } from './../../utils';
import useStore from './../../store';
import { ChoroplethLegend } from '../../Legend/ChoroplethLegend';
/** Returns a name for the feature */

var getFeatureLabel = function getFeatureLabel(feature) {
  var source = UNTD_LAYERS.find(function (item) {
    return item.id === feature.source;
  });
  var layerID = feature.layer.source;
  var label = feature.properties[source.label_key] ? feature.properties[source.label_key] : false;

  switch (layerID) {
    case 'zip':
      return i18n.translate("TOOLTIP_PLACE_ZIP", {
        label: label
      });

    case 'tract':
      return i18n.translate("TOOLTIP_PLACE_TRACT", {
        label: label
      });

    case 'county':
      return i18n.translate("TOOLTIP_PLACE_COUNTY", {
        label: label
      });

    default:
      return label;
  }
};

var getActiveQuintile = function getActiveQuintile(activeMetric, feature) {
  var quintile = Number(feature.properties[activeMetric]);
  return isNaN(quintile) ? [] : [quintile];
};

var PointPopup = function PointPopup(_ref) {
  var feature = _ref.feature;
  var hasAddress = feature.properties.Address && feature.properties.Address !== 'null';
  return /*#__PURE__*/React.createElement("div", {
    className: "popup-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "popup-place-name"
  }, /*#__PURE__*/React.createElement("h4", null, feature.properties.Name)), /*#__PURE__*/React.createElement("div", {
    className: "popup-metric",
    key: "popup-point-" + getFeatureId(feature)
  }, /*#__PURE__*/React.createElement("div", {
    className: "popup-metric-label address"
  }, feature.properties.Display, /*#__PURE__*/React.createElement("br", null), hasAddress && feature.properties.Address, hasAddress && /*#__PURE__*/React.createElement("br", null), feature.properties.City)), /*#__PURE__*/React.createElement("p", {
    className: "hint mt-3"
  }, i18n.translate('POPUP_CLICK_TO_FEEDBACK')));
};

var CountyPopup = function CountyPopup(_ref2) {
  var feature = _ref2.feature;
  var featureLabel = getFeatureLabel(feature);
  return /*#__PURE__*/React.createElement("div", {
    className: "popup-content"
  }, !!featureLabel && /*#__PURE__*/React.createElement("div", {
    className: "popup-place-name"
  }, /*#__PURE__*/React.createElement("h4", null, featureLabel)), /*#__PURE__*/React.createElement("p", {
    className: "hint mt-3"
  }, i18n.translate('POPUP_CLICK_TO_FEEDBACK')));
};
/**
 * Returns popup contents for map feature mouseover
 */


var DataPopup = function DataPopup(_ref3) {
  var feature = _ref3.feature;

  var _useStore = useStore(function (state) {
    return {
      indicators: state.indicators,
      activeMetric: state.activeMetric,
      allData: state.allData,
      tooltipItems: state.tooltipItems
    };
  }, shallow),
      indicators = _useStore.indicators,
      activeMetric = _useStore.activeMetric,
      allData = _useStore.allData,
      tooltipItems = _useStore.tooltipItems;

  var metric = indicators.find(function (item) {
    return item.id === activeMetric;
  });
  var rawMetric = allData.find(function (d) {
    return d.variable === activeMetric.replace('_sd', '');
  });
  var featureLabel = getFeatureLabel(feature);
  var value = feature.properties[rawMetric.variable];
  var isNumberValue = hasValue(value);
  var formattedValue = isNumberValue ? getRoundedValue(value, Number(rawMetric.decimals), false, Number(rawMetric.currency), Number(rawMetric.percent)) : 'Not available';
  var valueLabel = i18n.translate(rawMetric.variable);
  return /*#__PURE__*/React.createElement("div", {
    className: "popup-content"
  }, !!featureLabel && /*#__PURE__*/React.createElement("div", {
    className: "popup-place-name"
  }, /*#__PURE__*/React.createElement("h4", null, featureLabel)), /*#__PURE__*/React.createElement("div", {
    className: "popup-metric",
    key: "popup-metric-" + metric.id
  }, /*#__PURE__*/React.createElement("div", {
    className: "popup-metric-label"
  }, valueLabel, ":", ' ', /*#__PURE__*/React.createElement("span", {
    className: "metric-value"
  }, formattedValue)), /*#__PURE__*/React.createElement("div", {
    className: "popup-metric-scale"
  }, /*#__PURE__*/React.createElement(ChoroplethLegend, {
    activeIndexes: getActiveQuintile(activeMetric, feature),
    labelIndexes: getActiveQuintile(activeMetric, feature),
    noLabels: true,
    condensed: true
  })), /*#__PURE__*/React.createElement("div", {
    className: clsx('popup-indicator-list')
  }, tooltipItems.sort(function (a, b) {
    return a.order - b.order;
  }).map(function (el) {
    if (!feature.properties[el.id]) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "indicator-item",
      key: "indicator-item-" + el.id
    }, /*#__PURE__*/React.createElement("span", {
      className: clsx('indicator-title')
    }, i18n.translate(el.id), ":"), ' ', /*#__PURE__*/React.createElement("span", {
      className: clsx('indicator-value')
    }, getRoundedValue(feature.properties[el.id], el.decimals, true, el.currency, el.percent)));
  }))), /*#__PURE__*/React.createElement("p", {
    className: "hint mt-3"
  }, i18n.translate('POPUP_CLICK_TO_LEARN')));
};
/**
 * Returns popup contents for map feature mouseover
 */


var PopupContent = function PopupContent(_ref4) {
  var feature = _ref4.feature;
  if (!feature) return null;
  if (feature.layer.source.indexOf('points') > -1) return /*#__PURE__*/React.createElement(PointPopup, {
    feature: feature
  }); // NOTE: lane - june 15, 2021
  //  not sure if county popups are actually used?
  //  leaving in just in case

  if (feature.layer.source.indexOf('county') > -1) return /*#__PURE__*/React.createElement(CountyPopup, {
    feature: feature
  }); // Popup for census tracts, cities, zips

  return /*#__PURE__*/React.createElement(DataPopup, {
    feature: feature
  });
};

export default PopupContent;